import React from 'react';

// Material-UI
import { Tooltip, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { styled, useTheme } from '@mui/material/styles';

export default function InfoTooltip(props) {
    const { message } = props;
    const theme = useTheme();

    return (
        <Tooltip
            arrow
            disableFocusListener
            placement="top"
            enterTouchDelay={0}
            leaveTouchDelay={5000}
            title={message || ''}
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: theme.palette.secondary.main,
                        fontSize: '1rem',
                    },
                },
                arrow: {
                    sx: {
                        color: theme.palette.secondary.main,
                    },
                },
            }}
        >
            <TooltipIconButton size="large">
                <HelpOutlineIcon color="info" fontSize="small" />
            </TooltipIconButton>
        </Tooltip>
    );
}

const TooltipIconButton = styled(IconButton)(() => ({
    padding: 0,
}));
